"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useDynamicBullet(_ref) {
  var activeIndex = _ref.activeIndex,
      slideLength = _ref.slideLength;

  var _react_1$useState = react_1.useState(0),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      viewportWidth = _react_1$useState2[0],
      setViewportWidth = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(0),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      bulletCounts = _react_1$useState4[0],
      setBulletCounts = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(0),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      circlePositionX = _react_1$useState6[0],
      setCirclePositionX = _react_1$useState6[1];

  var _react_1$useState7 = react_1.useState(0),
      _react_1$useState8 = _slicedToArray(_react_1$useState7, 2),
      centerPosition = _react_1$useState8[0],
      setCenterPosition = _react_1$useState8[1];

  react_1.useEffect(function () {
    var draftCenterPosition = 2 + circlePositionX;
    var distanceFromActiveIndex = centerPosition - activeIndex; // 2 is center dot (··>·<··)

    var draftCirclePositionX = circlePositionX;

    if (Math.abs(distanceFromActiveIndex) >= 3) {
      var isRightMove = distanceFromActiveIndex <= -3;
      var isLeftMove = distanceFromActiveIndex >= 3;

      if (isRightMove) {
        draftCirclePositionX = circlePositionX + 1;
        draftCenterPosition += 1;
      } else if (isLeftMove) {
        draftCirclePositionX = circlePositionX - 1;
        draftCenterPosition -= 1;
      }

      setCirclePositionX(draftCirclePositionX);
    }

    var leftRemailBulletCount = draftCenterPosition - 2;
    var rightRemailBulletCount = slideLength - 1 - (draftCenterPosition + 2);
    leftRemailBulletCount = leftRemailBulletCount > 2 ? 2 : leftRemailBulletCount;
    rightRemailBulletCount = rightRemailBulletCount > 2 ? 2 : rightRemailBulletCount;
    setCenterPosition(draftCenterPosition); // center size : 54
    // bullet size: 12

    setViewportWidth(54 + (leftRemailBulletCount + rightRemailBulletCount) * 12);
    var sumBulletCounts = leftRemailBulletCount + rightRemailBulletCount;
    setBulletCounts(sumBulletCounts < 0 ? 0 : sumBulletCounts);
  }, [activeIndex]);
  return {
    viewportWidth: viewportWidth,
    bulletCounts: bulletCounts,
    circlePositionX: circlePositionX,
    centerPosition: centerPosition
  };
}

exports.default = useDynamicBullet;